import styled from "styled-components"
import { usePwaInstall } from "./usePwaInstall"

const InstallButton = styled.button`
  min-height: 42px;
  padding: 0 1rem;
  border: 1px solid rgba(51, 122, 189, 0.34);
  border-radius: 2px;
  background: rgba(51, 122, 189, 0.08);
  color: inherit;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 750;
  cursor: pointer;

  &:hover {
    background: rgba(51, 122, 189, 0.14);
  }
`

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: rgba(4, 18, 32, 0.78);
`

const Instructions = styled.div`
  width: min(460px, 100%);
  padding: 2rem;
  border: 1px solid #b9c9d6;
  border-top: 4px solid #337abd;
  border-radius: 2px;
  background: #ffffff;
  color: #102840;
  box-shadow: 0 30px 80px rgba(3, 20, 36, 0.3);

  h2 {
    margin: 0 0 0.75rem;
    font-size: 1.7rem;
  }

  ol {
    margin: 1.25rem 0;
    padding-left: 1.25rem;
    line-height: 1.7;
  }
`

const Close = styled.button`
  width: 100%;
  min-height: 46px;
  border: 0;
  border-radius: 2px;
  background: #0d4172;
  color: #ffffff;
  font: inherit;
  font-weight: 750;
  cursor: pointer;
`

interface InstallPortalButtonProps {
  label?: string
}

const InstallPortalButton = ({ label = "Installer l’Espace TB" }: InstallPortalButtonProps) => {
  const { canInstall, install, isIos, showInstructions, closeInstructions } = usePwaInstall()

  if (!canInstall && !showInstructions) {
    return null
  }

  return (
    <>
      {canInstall && <InstallButton onClick={install}>{label}</InstallButton>}
      {showInstructions && (
        <Overlay role="presentation" onMouseDown={closeInstructions}>
          <Instructions role="dialog" aria-modal="true" aria-labelledby="install-title" onMouseDown={(event) => event.stopPropagation()}>
            <h2 id="install-title">Ajouter l’Espace TB à votre écran</h2>
            {isIos ? (
              <ol>
                <li>Dans Safari, touchez le bouton Partager.</li>
                <li>Choisissez « Ajouter à l’écran d’accueil ».</li>
                <li>Confirmez avec « Ajouter ».</li>
              </ol>
            ) : (
              <ol>
                <li>Ouvrez le menu de votre navigateur.</li>
                <li>Choisissez « Installer l’application » ou « Ajouter à l’écran d’accueil ».</li>
                <li>Confirmez l’installation.</li>
              </ol>
            )}
            <Close onClick={closeInstructions}>J’ai compris</Close>
          </Instructions>
        </Overlay>
      )}
    </>
  )
}

export default InstallPortalButton
